import { Config } from "app/core/vo/config";
import { Logger } from "../../helpers/Logger";
import { Observable } from "rxjs";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { Scorm } from "./scorm";

export class Scorm2004 extends Scorm {
	protected interactionList = [];

	protected initProperties(data) {
		super.initProperties(data);
		this.bInteractionEnabled = true;
	}
	public doInitialize() {
		super.doInitialize();
	}
	public doCommit(): boolean {
		super.doCommit();
		return true;
	}
	public forceSave() {
		//this.saveInteraction();
		super.forceSave();
	}

	public doFinish(): any {
		super.doFinish();
		return true;
	}

	protected setLessonData() {
		super.setLessonData();
		this.setInteractionCount();
	}

	public updateScreenInteraction(): void {
		//console.log("Update Interaction called");
		this.saveInteraction();
	}

	// setInteractionCount() stores interaction count, which will be used to store interactions to LMS
	protected setInteractionCount(): void {
		this.trackingVO.interactionCount = parseInt(
			this.doGetValue("cmi.interactions._count")
		);
	}

	// setInteraction() method stores interactions to class variable interactionList and all the interactions in the list for a page will be pushed to LMS from saveInteraction() method
	public setInteraction(
		id: string,
		type: string,
		description: string,
		learner_response: string,
		result: string,
		latency: string
	): void {
		//console.log("setting Interaction");
		if (!this.checkInteractionSavedWithID(id)) {
			let interactionVO = {
				id: "",
				type: "",
				description: "",
				learner_response: "",
				result: "",
				latency: "",
			};
			interactionVO.id = id;
			interactionVO.type = type;
			interactionVO.description = description;
			interactionVO.learner_response = learner_response;
			interactionVO.result = result;
			interactionVO.latency = latency;
			this.interactionList.push(interactionVO);
		}
	}

	// saveInteraction() method sends stored interactions in class variable interactionList to LMS. Method is called on page completion.
	public saveInteraction(): void {
		let interactionVO = {
			id: "",
			type: "",
			description: "",
			learner_response: "",
			result: "",
			latency: "",
		};
		while (this.interactionList.length) {
			interactionVO = this.interactionList.splice(0, 1)[0];
			console.log("Tracking VO ", this.trackingVO.interactionCount);
			this.doSetValue(
				"cmi.interactions." + this.trackingVO.interactionCount + ".id",
				this.interactionPrefix + interactionVO.id
			);
			this.doSetValue(
				"cmi.interactions." + this.trackingVO.interactionCount + ".type",
				interactionVO.type
			);
			this.doSetValue(
				"cmi.interactions." + this.trackingVO.interactionCount + ".description",
				interactionVO.description
			);
			this.doSetValue(
				"cmi.interactions." +
					this.trackingVO.interactionCount +
					".learner_response",
				interactionVO.learner_response
			);
			this.doSetValue(
				"cmi.interactions." + this.trackingVO.interactionCount + ".result",
				interactionVO.result
			);
			this.doSetValue(
				"cmi.interactions." + this.trackingVO.interactionCount + ".latency",
				interactionVO.latency
			);
			++this.trackingVO.interactionCount;
		}
	}

	// checkInteractionSavedWithID() method checks all stored interactions for duplication againt interaction id
	protected checkInteractionSavedWithID(id: String): Boolean {
		let bSaved = false;
		let count = 0;
		let countLen = this.interactionList.length;
		for (count = 0; count < countLen; ++count) {
			if (this.interactionList[count].id == id) {
				bSaved = true;
				break;
			}
		}
		return bSaved;
	}
}
